import PropTypes from 'prop-types'
import { Button, Typography } from 'antd'

const { Text } = Typography

// Compact, fixed-height cell for the "Receives alerts for" column: a truncated
// summary of the selected medical providers plus an Edit action that opens the
// modal. Keeps table rows a uniform height regardless of how many are selected.
export default function AlertProvidersCell({ value = [], labelById = {}, onEdit }) {
  // Ids without a label are providers the options endpoint no longer returns
  // (deactivated) or not-yet-loaded options; never leak the raw uuid.
  const names = value.map(id => labelById[id] || 'Inactive provider')

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, maxWidth: 340 }}>
      <Text
        type={value.length ? undefined : 'secondary'}
        ellipsis={value.length ? { tooltip: names.join(', ') } : false}
        style={{ flex: 1, minWidth: 0 }}
      >
        {value.length ? names.join(', ') : 'No medical providers'}
      </Text>
      <Button type="link" size="small" style={{ padding: 0 }} onClick={onEdit}>
        Edit
      </Button>
    </div>
  )
}

AlertProvidersCell.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  labelById: PropTypes.objectOf(PropTypes.string),
  onEdit: PropTypes.func.isRequired,
}
